import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11e80944"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "close", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "gallery_container" }
const _hoisted_6 = { class: "gallery_photos" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "gallery_thumbnails" }
const _hoisted_9 = { class: "thumbnails" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "number" }
const _hoisted_12 = {
  key: 0,
  class: "modal-backdrop"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.hide && _ctx.hide(...args))),
            id: "close-button"
          }, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", { src: _ctx.currImg }, null, 8, _hoisted_7),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.prevSlide && _ctx.prevSlide(...args))),
                class: "nav_button left"
              }, "❮"),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.nextSlide && _ctx.nextSlide(...args))),
                class: "nav_button right"
              }, "❯")
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayList, (img) => {
                  return (_openBlock(), _createElementBlock("img", {
                    src: img,
                    onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.setSlide && _ctx.setSlide(...args)))
                  }, null, 8, _hoisted_10))
                }), 256))
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.currIdx + 1) + " / " + _toDisplayString(_ctx.currSize), 1)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.modalState]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.modalState)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}